<div class="risk-dictionary-group-form-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      (click)="addRisk()"
      mat-stroked-button
      color="accent"
    ><mat-icon>add</mat-icon> <span> Dodaj konfigurację</span></button>

    <button
      (click)="save()" [class.spinner]="processingRequest"
      [disabled]="processingRequest || !formGroupsValid"
      mat-stroked-button color="primary"
    ><mat-icon>save</mat-icon> <span> Zapisz</span></button>

    <button
      (click)="cancel()"
      mat-stroked-button
      color="warn"
    ><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100">

    <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <h3>Konfiguracje</h3>

      <ng-container>
        <ng-container *ngFor="let formGroup of formGroups.controls; index as i" [formGroup]="$any(formGroup)">
          <div fxFlex="100" fxLayout="column" fxLayoutGap="15px" class="mat-elevation-z2 risk-dictionary-record-container">
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
              <div fxFlex="25px" class="list-counter">
                <span>{{i+1}}.</span>
              </div>

              <div fxFlex class="risk-dictionary-group-form-field">
                <app-dict
                  label="Ryzyko ASF" [control]="$any(formGroup.get('internalRisk'))"
                  dictType="internal_risk"
                ></app-dict>
              </div>

              <div fxFlex class="risk-dictionary-group-form-field">
                <mat-form-field fxFlex>
                  <mat-label>Grupa ryzyk</mat-label>
                  <input matInput placeholder="Grupa ryzyk" formControlName="groupName" [required]="false">
                </mat-form-field>
              </div>

              <div fxFlex class="risk-dictionary-group-form-field">
                <app-chips-input-control fxFlex label="Kod ryzyka" [arrayControl]="$any(formGroup.get('name'))"></app-chips-input-control>
              </div>

              <div fxFlex class="risk-dictionary-group-form-field">
                <app-chips-input-control fxFlex label="Stawki % TU" [arrayControl]="$any(formGroup.get('rates'))"></app-chips-input-control>
              </div>

              <div fxLayout="row" fxLayoutAlign="space-around end" class="actions-container">
                <div fxFlex>
                  <button
                    (click)="removeRisk(i)"
                    mat-icon-button color="warn"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>

            </div>

          </div>
        </ng-container>

        <div fxLayout="row" fxLayoutGap="15px">
          <button
            (click)="addRisk()"
            mat-stroked-button
            color="accent"
          ><mat-icon>add</mat-icon> <span> Dodaj konfigurację</span></button>
        </div>
      </ng-container>
    </mat-card>

  </div>
</div>
